import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		sideBar: JSON.parse(localStorage.getItem("sideBar")),
		userInfo: JSON.parse(localStorage.getItem('userInfo'))
	},
	mutations: {
		setUserInfo(state, user) {
			state.userInfo = user;
			localStorage.setItem('userInfo', JSON.stringify(user));
		}
	}
})

export default store
